import { Shield } from "lucide-react";
import { useState } from "react";

function PrivacyPolicyModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm" onClick={onClose}>
      <div
        className="bg-white rounded-xl shadow-2xl max-w-2xl w-full mx-4 max-h-[80vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 bg-white border-b px-6 py-4 flex items-center justify-between rounded-t-xl" style={{ borderColor: "#E5E7EB" }}>
          <h2 className="text-lg font-bold" style={{ color: "#1C2040" }}>Privacy Policy</h2>
          <button onClick={onClose} className="text-sm font-medium px-3 py-1 rounded-md hover:bg-gray-100 transition" style={{ color: "#6B7491" }}>
            Close
          </button>
        </div>
        <div className="px-6 py-5 space-y-4 text-sm leading-relaxed" style={{ color: "#3D4363" }}>
          <p><strong>Effective Date:</strong> January 1, 2026</p>

          <h3 className="font-semibold text-base" style={{ color: "#1C2040" }}>1. Information We Collect</h3>
          <p>We collect information you provide when creating an account, connecting integrations, and using our analytics services. This includes your name, email address, business data synced from third-party platforms (e.g., HubSpot), and usage patterns within the application.</p>

          <h3 className="font-semibold text-base" style={{ color: "#1C2040" }}>2. How We Use Your Information</h3>
          <p>Your data is used to deliver and improve our business intelligence services, generate financial analytics and reports, provide AI-powered insights, and communicate important account updates.</p>

          <h3 className="font-semibold text-base" style={{ color: "#1C2040" }}>3. Data Security</h3>
          <p>We implement industry-standard security measures including encryption in transit and at rest, access controls, and regular security audits to protect your information.</p>

          <h3 className="font-semibold text-base" style={{ color: "#1C2040" }}>4. Third-Party Integrations</h3>
          <p>When you connect third-party services (such as HubSpot CRM), we access and process data according to the permissions you grant via OAuth. We do not share your data with unrelated third parties without your consent.</p>

          <h3 className="font-semibold text-base" style={{ color: "#1C2040" }}>5. Data Retention</h3>
          <p>We retain your data for as long as your account is active or as needed to provide services. You may request deletion of your data at any time by contacting our support team.</p>

          <h3 className="font-semibold text-base" style={{ color: "#1C2040" }}>6. Your Rights</h3>
          <p>You have the right to access, correct, or delete your personal data. You may also opt out of non-essential communications at any time through your account settings.</p>

          <h3 className="font-semibold text-base" style={{ color: "#1C2040" }}>7. Contact</h3>
          <p>For privacy-related inquiries, please contact us at <strong>privacy@onpoint.bi</strong>.</p>
        </div>
      </div>
    </div>
  );
}

export default function Footer() {
  const [showPolicy, setShowPolicy] = useState(false);

  return (
    <>
      <footer
        data-testid="app-footer"
        className="w-full py-3 px-6 flex items-center justify-between text-xs shrink-0"
        style={{ color: "#8A90A7", borderTop: "1px solid #E8EAF0" }}
      >
        <span data-testid="footer-copyright">&copy; 2026 OnPointBI. All rights reserved.</span>
        <button
          data-testid="footer-privacy-policy-link"
          onClick={() => setShowPolicy(true)}
          className="hover:underline transition-colors"
          style={{ color: "#6B7491" }}
        >
          <span className="inline-flex items-center gap-1">
            <Shield className="w-3 h-3" />
            Privacy Policy
          </span>
        </button>
      </footer>
      <PrivacyPolicyModal open={showPolicy} onClose={() => setShowPolicy(false)} />
    </>
  );
}
